module.exports = __webpack_public_path__ + "img/icon-zkzj.e1805895.png";